"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPreviewVoiceAsterisk = void 0;
const utils_1 = require("../utils");
const enums_1 = require("../../utilities/enums");
const base = Object.assign({ id: 1, title: 'Asterisk One', status: enums_1.AsteriskStatusEnum.Offline, host: '', internal_host: '', port: 1, tls: false, __organization_ids: [], iso2: 'SE', __is_downgraded: false, voice_asterisk_downgrade: null, voice_asterisk_downgrade_id: null, ari_based: true }, utils_1.mockDateObject);
exports.mockPreviewVoiceAsterisk = (0, utils_1.mockFunction)(Object.assign({}, base));
